import React, { useRef, useState } from "react";
import { Loader, Dimmer } from "semantic-ui-react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { formatMoneda, formatoMonto, onCambioMoneda, validaMonto, validaSoloNumero } from "../../util/varios";
import { Mensaje, MensajeSiNo } from "../mensajes";
import CatalogoProducto from "../../catalogos/catalogoProducto";

export const GestionarpServicios = (props) => {
  var op = require("../../../public/modulos/datos");
  let token = sessionStorage.getItem("jwtToken");
  const fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
  const accgservicios = JSON.parse(sessionStorage.getItem("accgserviciosc"));
  const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnSalir = useRef();
  const txtIdServicio = useRef();
  const txtDescripcion = useRef();
  const txtIdalmacen = useRef();
  const txtIdmoneda = useRef();
  const txtIva = useRef();
  const txtMonto = useRef();
  const txtCodigo = useRef();
  const [tituloHeader, setTituloHeader] = useState(
    "Servicios."
  );
  const [imagen, setImagen] = useState({
    imagen: "subir.png",
    imagenactual: "subir.png",
  });
  const [visibleBtn, setVisibleBtn] = useState("visible");
  const [operacion, setOperacion] = useState(null);
  const [body, setBody] = useState(null);
  const [activate, setActivate] = useState(false);
  const [habilitado, setHabilitado] = useState(true);
  const [acepta, setAcepta] = useState(true);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [combomoneda, setComboMoneda] = useState([]);
  const [catalogoModelo, setCatalogoModelo] = useState(false);
  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    salir: false,
  });
  const [monedaSub, setMonedaSub] = useState({
    idmoneda: "4",
    descripcion: "DOLAR",
    simbolo: "$",
    predeterminada: false,
    subpredeterminada: true,
    valormoneda: 1.0,
  });
  const [monedaCambio, setMonedaCambio] = useState({
    idmoneda: "4",
    descripcion: "DOLAR",
    simbolo: "$",
    predeterminada: false,
    subpredeterminada: true,
    valormoneda: 1.0,
  });
  const [moneda, setMoneda] = useState({
    idmoneda: "1",
    descripcion: "BOLIVARES",
    simbolo: "Bs",
    predeterminada: true,
    subpredeterminada: false,
    valormoneda: 1.0,
  });

  const onChange = (e) => {
    if (e.target.name === "descripcion") {
      if (e.target.value === "") {
        setBotones({ ...botones, aceptar: true });
      } else {
        setBotones({ ...botones, aceptar: false });
      }
      e.target.value = e.target.value;
    } else {
      e.target.value = e.target.value;
    }
  };

  const seleccionarCodigo = () => {
    let campos = "count(idproducto) as codigo";
    let nomtab = "producto";
    let nomid = "servicio";
    let id = true;
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.codigo > 0) {
            let to = response.data.codigo;
            to = parseFloat(to) + 1;
            txtCodigo.current.value = "SERV0000" + to;
          } else {
            txtCodigo.current.value = "SERV00001";
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);

    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const onCatalogoServicio = (values) => {
    setCatalogoModelo(false);
    txtIdServicio.current.value = values.idproducto;
    txtCodigo.current.value = values.codigo;
    txtDescripcion.current.value = values.nombre;
    txtIva.current.value = values.ivaventa;
    txtMonto.current.value = values.preciomax;
    if (operacion !== 4) {
      setAcepta(false);
    }
  };

  const onChangeValidar = () => {
    let sigue = true;
    if (!botones.incluir || !botones.modificar) {
      if (txtDescripcion.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe ingresar una descripción",
          icono: "informacion",
        });
        txtDescripcion.current.focus();
        sigue = false;
      } else if (txtMonto.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Introduzca el Monto del Servicio",
          icono: "informacion",
        });
        txtMonto.current.focus();
        sigue = false;
      }
    }

    if (sigue) {
      var prod = [];
      prod.push({
        idproducto: operacion === 1 ? 0 : txtIdServicio.current.value,
        codigo: txtCodigo.current.value.toUpperCase(),
        nombre: txtDescripcion.current.value.toUpperCase(),
        servicio: true,
        nombrecorto: txtDescripcion.current.value.toUpperCase(),
        idtipoproducto: 0,
        marca: null,
        modelo: null,
        referencia: null,
        diasgarantia: null,
        idunidadmedida: null,
        idmoneda: monedaSub.idmoneda,
        ivacompra: 0,
        ivaventa: parseFloat(
          txtIva.current.value.replace(/\./g, "").replace(",", ".")
        ),
        exento: 0,
        idtipoproducto: 2,
        tipoprecio: 1,
        almacen: true,
        stockminimo: 1,
        metodocosto: 1,
        costoproveedor: 0,
        costocalculado: parseFloat(
          txtMonto.current.value.replace(/\./g, "").replace(",", ".")
        ),
        ultimocosto: parseFloat(
          txtMonto.current.value
            .replace(/\./g, "")
            .replace(",", ".")
        ),
        costopromedio: parseFloat(
          txtMonto.current.value.replace(/\./g, "").replace(",", ".")
        ),
        utipreciomaxi: parseFloat(
          txtMonto.current.value.replace(/\./g, "").replace(",", ".")
        ),
        utiprecioofe: parseFloat(
          txtMonto.current.value.replace(/\./g, "").replace(",", ".")
        ),

        utipreciomayor: parseFloat(
          txtMonto.current.value.replace(/\./g, "").replace(",", ".")
        ),
        utipreciomini: parseFloat(
          txtMonto.current.value.replace(/\./g, "").replace(",", ".")
        ),

        ///precio venta
        preciomaxi: parseFloat(
          txtMonto.current.value.replace(/\./g, "").replace(",", ".")
        ),
        precioofe: parseFloat(
          txtMonto.current.value.replace(/\./g, "").replace(",", ".")
        ),
        preciomayor: parseFloat(
          txtMonto.current.value
            .replace(/\./g, "")
            .replace(",", ".")
        ),
        preciomini: parseFloat(
          txtMonto.current.value.replace(/\./g, "").replace(",", ".")
        ),

        idunidadalterna: "0",
        idunidadcompra: "0",
        idunidadventa: "0",
        valorfactor: "0.00",
        //tipofactor: radioSi.current.checked ? cmbUniFactor.current[cmbUniFactor.current.selectedIndex].text : '',
        tipofactor: 1,

        costoproveedoralter: "0.00",
        costocalculadoalter: "0.00",
        ultimocostoalter: "0.00",
        costopromedioalter: "0.00",
        utipreciomaxialter: "0.00",
        utiprecioofealter: "0.00",
        utipreciomayoralter: "0.00",
        utipreciominialter: "0.00",

        ///precio venta alterna
        preciomaxialter: "0.00",
        precioofealter: "0.00",
        preciomayoralter: "0.00",
        preciominialter: "0.00",
        idtipoingreso: "0",
        idfabricante: "0",
      });

      let upload = new FormData();
      console.log(prod);
      upload.append("producto", JSON.stringify(prod));
      upload.append("codigo", txtCodigo.current.value.toUpperCase());
      upload.append("imagenactual", imagen.imagenactual);
      upload.append("imagennueva", imagen.imagen);

      setBody(upload);

      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos.";
      } else if (operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const procesarRegistro = () => {
    setActivate(true);
    let ope = 0;
    if (!botones.incluir) {
      ope = 1;
    } else if (!botones.modificar) {
      ope = 2;
    } else if (!botones.eliminar) {
      ope = 3;
    }
    let endpoint = `${op.conexion}/api/producto/actualizar/${operacion}`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Registro Creado Correctamente",
              icono: "exito",
            });
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Registro Modificado Correctamente",
              icono: "exito",
            });
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Registro Eliminado Correctamente",
              icono: "exito",
            });
          }
          setActivate(false);
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response === undefined) {
          mensaje = "Error de Conexion";
        } else {
          if (
            error.response.data.message ===
            'duplicate key value violates unique constraint "ubicacion_key"'
          ) {
            mensaje = "Ya existe un Registro con este Código";
          } else {
            mensaje = error.response.data.message;
          }
        }
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (
      mensajesino.texto === "Seguro de Descartar Cambios?" &&
      props.llamado === 2
    ) {
      cancelar();
    } else {
      procesarRegistro();
    }
  };

  const blanquear = () => {
    setActivate(false);
    setTituloHeader("Servicios.");
    setBody(null);
    setHabilitado(true);
    setComboMoneda([]);
    setAcepta(true);
    setBotones({
      incluir: false,
      consultar: false,
      modificar: false,
      eliminar: false,
      aceptar: true,
      cancelar: true,
      catalogo: true,
      salir: false,
    });
    txtIdServicio.current.setAttribute("disabled", true);
    txtDescripcion.current.value = "";
    txtIva.current.value = 0.00;
    txtMonto.current.value = "";
    txtCodigo.current.value = "";
    setVisibleBtn("visible");
    setMonedaCambio({
      idmoneda: "4",
      descripcion: "DOLAR",
      simbolo: "$",
      predeterminada: false,
      subpredeterminada: true,
      valormoneda: 1.0,
    });
    for (let i = 0; i < combomoneda.length; i++) {
      if (combomoneda[i].idmoneda === monedaSub.idmoneda) {
        txtIdmoneda.current.selectedIndex = i;
      }
    }
  };

  const seleccionarMonedas = () => {
    let campos =
      "m.idmoneda, m.descripcion, m.simbolo, m.predeterminada,  m.subpredeterminada, md.valor as valormoneda, md.fecha";
    let nomtab =
      "moneda as m left join monedadetalle as md on m.idmoneda=md.idmoneda where md.fecha = (SELECT MAX(fecha) AS fecha FROM monedadetalle where idmoneda=m.idmoneda)";
    let orden = "m.idmoneda";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          let x = 0;
          if (response.data.length > 0) {
            setComboMoneda(response.data);
            for (let i = 0; i < response.data.length; i++) {
              if (response.data[i].subpredeterminada) {
                setMonedaSub(response.data[i]);
                setMonedaCambio({
                  idmoneda: response.data[i].idmoneda,
                  descripcion: response.data[i].descripcion,
                  simbolo: response.data[i].simbolo,
                  predeterminada: response.data[i].predeterminada,
                  subpredeterminada: response.data[i].subpredeterminada,
                  valormoneda: 1.0,
                });
                x = i;
              } else if (response.data[i].predeterminada) {
                setMoneda(response.data[i]);
              }
            }
          }
          setTimeout(() => (txtIdmoneda.current.selectedIndex = x), 200);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancela();
  };

  const onBotones = (op) => (e) => {
    e.preventDefault();

    if (op === 1) {
      if (accgservicios && accgservicios.toString().substring(0, 1) === "1") {
        setVisibleBtn("collapse");
        seleccionarMonedas();
        setTituloHeader("Incluir Servicio.");
        seleccionarCodigo();
        setOperacion(op);
        setHabilitado(false);
        setAcepta(false);
        setBotones({
          incluir: false,
          consultar: true,
          modificar: true,
          eliminar: true,
          aceptar: false,
          cancelar: false,
          catalogo: true,
          salir: true,
        });
        txtIva.current.value = 0.00;
        setTimeout(() => txtCodigo.current.focus(), 200);
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 2) {
      if (accgservicios && accgservicios.toString().substring(1, 2) === "1") {
        setVisibleBtn("collapse");
        seleccionarMonedas();
        setTituloHeader("Editar Servicio.");
        setOperacion(op);
        setHabilitado(false);
        setAcepta(true);
        setBotones({
          incluir: true,
          consultar: true,
          modificar: false,
          eliminar: true,
          aceptar: false,
          cancelar: false,
          catalogo: false,
          salir: true,
        });
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 3) {
      if (accgservicios && accgservicios.toString().substring(3, 4) === "1") {
        setVisibleBtn("collapse");
        seleccionarMonedas();
        setHabilitado(true);
        setTituloHeader("Eliminar Servicio.");
        setOperacion(op);
        setAcepta(true);
        setBotones({
          incluir: true,
          consultar: true,
          modificar: true,
          eliminar: false,
          aceptar: false,
          cancelar: false,
          catalogo: false,
          salir: true,
        });
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 4) {
      if (accgservicios && accgservicios.toString().substring(2, 3) === "1") {
        setVisibleBtn("collapse");
        setTituloHeader("Consultar Servicio.");
        setOperacion(op);
        seleccionarMonedas();
        setAcepta(true);
        setHabilitado(true);
        setBotones({
          incluir: true,
          consultar: false,
          modificar: true,
          eliminar: true,
          aceptar: true,
          cancelar: false,
          catalogo: false,
          salir: true,
        });
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 5) {
      onChangeValidar();
    } else if (op === 6) {
      if (props.llamado === 2) {
        if (txtDescripcion.current.value === "") {
          blanquear();
          props.onHideCancela();
        } else {
          setMensajesino({
            mostrar: true,
            titulo: "Confirmación.",
            texto: "Seguro de Descartar Cambios?",
            icono: "confirmacion",
          });
        }
      } else {
        blanquear();
      }
    } else if (op === 7) {
      setVisibleBtn("visible");
      cancelar();
    }
  };

  const cerrarModal = () => {
    if (props.llamado === 2) {
      props.onHideRenderizar();
      props.onHideCancela();
    }
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const imprimirFabricantes = () => {
    /* window.open(
      `${op.reportes}/almacen?afiliado=${afiliado}&reporte=ListFabricantes`,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    ); */
  };

  const onChangeMoneda = (e) => {
    let i = e.target.value;
    const cambio = onCambioMoneda({
      moneda: combomoneda[i],
      productos: "",
      monedaPre: moneda,
      monedaSub: monedaSub,
    });
    setMonedaCambio(cambio.monedacambio);
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setHabilitado(true);
        if (props.llamado === 2) {
          setOperacion(1);
          setHabilitado(false);
          setBotones({
            incluir: false,
            consultar: true,
            modificar: true,
            eliminar: true,
            aceptar: true,
            cancelar: false,
            catalogo: true,
            salir: true,
          });
          setTimeout(() => txtCodigo.current.focus(), 200);
          setVisibleBtn("collapse");
        }
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <Modal.Title style={{ color: "#fff" }}>{tituloHeader} </Modal.Title>
        <a
          href="#"
          ref={btnSalir}
          disabled={botones.salir}
          onClick={onBotones(7)}
          className="text-light"
        >
          <i className="fas fa-times fa-1x shadow"> {/* Salir */}</i>
        </a>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} inverted>
          <Loader inverted>cargando...</Loader>
        </Dimmer>
        <div className="col-md-12 row mx-auto px-0">
          <div className="col-md-12 mx-auto px-0 row m-0">
            <input type="hidden" ref={txtIdServicio} />
            <div className="col-pd-230 mb-2 px-1">
              <div className="input-group input-group-sm px-0">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  CODIGO:
                </label>
                <input
                  type="text"
                  ref={txtCodigo}
                  disabled={habilitado}
                  /* onKeyUp={validarMarca}
                  onBlur={validarMarca} */
                  className="form-control fs-6"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                />
                <button
                  disabled={botones.catalogo}
                  type="button"
                  onClick={() => setCatalogoModelo(true)}
                  className="btn btn-success"
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>
            </div>

            <div className="col-pd-330 mb-2 mx-auto px-0">
              <div className="input-group input-group-sm">
                <label
                  className="input-group-text"
                  id="inputGroup-sizing-sm"
                >
                  TIPO DE MONEDA:
                </label>
                <select
                  className="form-control form-control-sm form-select fw-bold fs-6"
                  disabled={
                    operacion === 3 || operacion === 0 ? true : false
                  }
                  ref={txtIdmoneda}
                  onChange={onChangeMoneda}
                >
                  {combomoneda &&
                    combomoneda.map((item, index) => (
                      <option key={index} value={index}>
                        {" "}
                        {`${item.descripcion} ${item.simbolo
                          } ${formatMoneda(item.valormoneda.toString().replace(",", "").replace(".", ","), ",", ".", 2)}`}{" "}
                      </option>
                    ))}
                </select>
              </div>
            </div>
          </div>
          <div
            className="border-azul col-md-12 py-3 rounded mx-1"
            style={{ fontSizeAdjust: "0.6" }}
          >
            <div className="row col-md-12 rounded mx-auto">

              {/* <div className="col-md-1 ml-auto px-0">
                <div className="input-group input-group-sm">
                  <button
                    className="btn btn-primary btn-sm rounded "
                    onClick={imprimirFabricantes}
                  >
                    <i className="fas fa-print"></i>
                  </button>
                </div>
              </div> */}

              <div className="input-group input-group-sm col-md-12 px-0 mb-2">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  DESCRIPCION:
                </label>
                <textarea
                  type="text"
                  ref={txtDescripcion}
                  name="descripcion"
                  autoComplete="off"
                  disabled={habilitado}
                  style={{ height: "45px" }}
                  className="form-control text-uppercase fs-6"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  onChange={onChange}
                />
              </div>

              <div className="col-md-12 row m-0 px-0">
                <div className="col-pd-100 px-0 mb-1">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      IVA:{" "}
                    </label>
                    <input
                      autoComplete="off"
                      type="text"
                      disabled={habilitado}
                      ref={txtIva}
                      onKeyUp={handleInputMontoChange}
                      onBlur={handleInputMontoChange}
                      className="form-control bg-transparent fs-6 text-right"
                      aria-label="Sizing example input"
                      placeholder="0,00"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                </div>
                <div className="col-md-3 mb-1">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      MONTO:{" "}
                    </label>
                    <input
                      autoComplete="off"
                      type="text"
                      onKeyUp={handleInputMontoChange}
                      onBlur={handleInputMontoChange}
                      disabled={habilitado}
                      ref={txtMonto}
                      className="form-control bg-transparent fs-6 text-right"
                      aria-label="Sizing example input"
                      placeholder="0,00"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="col-md-12 mx-auto">
          {visibleBtn === "visible" ? (
            <div className="col-md-12 mx-auto row justify-content-between px-0">
              <button
                disabled={botones.incluir}
                onClick={onBotones(1)}
                className="btn btn-sm mx-1 my-1 col btn-primary rounded-pill"
                title="Incluir Modelo"
              >
                <i className="fas fa-plus"> Incluir </i>{" "}
              </button>
              <button
                disabled={botones.consultar}
                onClick={onBotones(4)}
                className="btn btn-sm mx-1 my-1 col btn-info rounded-pill"
                title="Consultar Modelo"
              >
                <i className="fas fa-eye">Consultar</i>{" "}
              </button>
              <button
                disabled={botones.modificar}
                onClick={onBotones(2)}
                className="btn btn-sm mx-1 my-1 col btn-warning rounded-pill"
                title="Modificar Modelo"
              >
                <i className="fa fa-edit">Modificar</i>{" "}
              </button>
              <button
                disabled={botones.eliminar}
                onClick={onBotones(3)}
                className="btn btn-sm mx-1 my-1 col btn-danger rounded-pill"
                title="Eliminar Modelo"
              >
                <i className="fa fa-trash">Eliminar</i>{" "}
              </button>
            </div>
          ) : (
            <div className="col-md-12 row mx-auto justify-content-end px-0">
              <button
                ref={btnAcepta}
                disabled={acepta}
                onClick={onBotones(5)}
                className="btn col-md-3 mx-1 my-1 btn-sm rounded-pill btn-success "
              >
                <i className="fas fa-check-circle"> Aceptar</i>
              </button>
              <button
                ref={btnCancela}
                disabled={botones.cancelar}
                onClick={onBotones(6)}
                className="btn col-md-3 mx-1 my-1 btn-danger btn-sm rounded-pill "
              >
                <i className="fas fa-window-close"> Cancelar</i>
              </button>
            </div>
          )}
        </div>
      </Modal.Footer>
      <CatalogoProducto
        show={catalogoModelo}
        esservicio={"1"}
        onHideCancelar={() => setCatalogoModelo(false)}
        onHideAceptaCatalogo={onCatalogoServicio}
      />
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/servicios/gestionarServicios.js